module.exports = __webpack_public_path__ + "img/dice-5.5aa9831c.svg";